module.exports = __webpack_public_path__ + "images/unigarantac22d1bfe5eed916202d210f80e31e55.png";